export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_05.e97ca80b.jpg";